export enum CommentType {
  VACAY = 1,
  ROSTR = 2,
  UNION_REPRESENTATIVE = 3
}
